import {
  CLOSE_POSITION_TABLE_PATH,
  DASHBOARD_CALENDAR_PATH,
  METRICS_PATH,
  OPEN_POSITION_TABLE_PATH,
} from '../../constants'
import AbstractService from '../../services/AbstractService'
import { ServerResponse } from '../../types'

import {
  DashboardMetricsDTO,
  DashboardRequestType,
  CalendarCellDataType,
  PositionsRequestType,
  PositionsTablesDTO,
  OpenPositions,
  ClosedPositions,
} from './types'

class DashboardServiceClass extends AbstractService {
  getWidgetsData = (data: DashboardRequestType) =>
    this.request<ServerResponse<DashboardMetricsDTO>>(METRICS_PATH, 'post', true, data)

  getCalendarData = (data: DashboardRequestType) =>
    this.request<ServerResponse<CalendarCellDataType[]>>(
      DASHBOARD_CALENDAR_PATH,
      'post',
      true,
      data,
    )

  getOpenPositions = (data: PositionsRequestType) =>
    this.request<ServerResponse<PositionsTablesDTO<OpenPositions>>>(
      OPEN_POSITION_TABLE_PATH,
      'post',
      true,
      data,
    )
  getClosePositions = (data: PositionsRequestType) =>
    this.request<ServerResponse<PositionsTablesDTO<ClosedPositions>>>(
      CLOSE_POSITION_TABLE_PATH,
      'post',
      true,
      data,
    )
}

export const DashboardService = new DashboardServiceClass()
